const DerivedRenderer = ({
  question,
  formData,
  onChange,
  isEditable = true
}) => {

  const schema =
    question.ui_schema || {};

  const fields =
    schema.fields || [];

  // ==========================================
  // CHECK TYPES
  // ==========================================

  const isLinkedDerived =
  fields.length > 0 &&
  (
    !!schema.source_question_code ||

    fields.some(
      (f) => f.source_question_code
    )
  );

const isInlineDerived =
  fields.length > 0 &&
  !schema.source_question_code &&
  !fields.some(
    (f) => f.source_question_code
  );
  
  const isAutoDerived =
    fields.length === 0;

  let result = 0;

  const isAggregationDerived =
  schema.aggregation === true;


// ==========================================
// AGGREGATION DERIVED (TABLE SUM)
// ==========================================

if (isAggregationDerived) {

  try {

    const sourceData =
  formData?.[
    schema.source_question_code
  ] || {};

const sourceRows =
  Array.isArray(sourceData)
    ? sourceData
    : sourceData.rows || [];

    const values = {};

    schema.fields.forEach((field) => {

      const total = sourceRows.reduce(
        (sum, row) => {

          return (
            sum +
            Number(
              row?.[field.key] || 0
            )
          );

        },
        0
      );

      values[
        field.alias
      ] = total;

    });

    let formula =
      schema.formula;

    formula = formula.replace(
      /\b[a-zA-Z_][a-zA-Z0-9_]*\b/g,
      (match) =>
        values[match] ?? 0
    );

    result = eval(formula);

    if (
      !isFinite(result) ||
      isNaN(result)
    ) {

      result = 0;
    }

    result =Number(result).toFixed(2);

  } catch (err) {

    console.error(err);

    result = 0;
  }

  return (

    <div className="ecf-derived-wrapper">

      <div className="ecf-derived-field">

        <label className="ecf-label">
          {schema.result?.label ||
            "Result"}
        </label>

        <input
          className="ecf-form-input"
          type="text"
          value={`${result}${
            question.unit_type || ""
          }`}
          readOnly
          disabled
        />

      </div>

    </div>

  );

}
  // ==========================================
  // CALCULATED DERIVED
  // ==========================================
if (
  isInlineDerived ||
  isLinkedDerived
) {

  try {

  let formula = schema.formula;

  const values = {};

  fields.forEach((field) => {

    let value = 0;

    // LINKED QUESTIONS
    if (field.source_question_code) {

      value = Number(
        formData?.[
          field.source_question_code
        ] || 0
      );

    }

    // INLINE INPUTS
    else {

      const rawValue =
        formData?.[
          `${question.question_code}.${field.key}`
        ];

      value =
        rawValue === "" ||
        rawValue === null ||
        rawValue === undefined
          ? 0
          : parseFloat(rawValue);

    }

    values[field.key] = value;

  });

  // SAFE VARIABLE REPLACEMENT
  formula = formula.replace(
    /\b[a-zA-Z_][a-zA-Z0-9_]*\b/g,
    (match) => values[match] ?? 0
  );

  result = eval(formula);

  if (
    !isFinite(result) ||
    isNaN(result)
  ) {

    result = 0;
  }

 result =
  parseFloat(
    Number(result).toFixed(2)
  );

  if (isLinkedDerived) {

  return (

    <div className="ecf-derived-result">

      <div className="ecf-derived-value">

        {result}

        {schema.unit
          ? ` ${schema.unit}`
          : question.unit_type || ""}

      </div>

    </div>

  );
}
} catch (err) {

  console.error(err);

  result = 0;
} 
}

  // ==========================================
  // AUTO DERIVED (P6 AUTO MODULES)
  // ==========================================

if (isAutoDerived) {

  const autoValue =
    formData[
      question.question_code
    ];

  return (

    <div className="ecf-derived-result">

      <div className="ecf-derived-auto-label">
        Auto Calculated
      </div>

      <div className="ecf-derived-value">

       {autoValue !== undefined &&
 autoValue !== null
  ? Number(autoValue)
      .toFixed(2)
  : "--"}

        {schema.unit
          ? ` ${schema.unit}`
          : ""}

      </div>

    </div>

  );

}
  

  // ==========================================
  // INLINE DERIVED (P1)
  // ==========================================

  return (

    <div className="ecf-derived-wrapper">

      {/* INPUTS */}

      <div className="ecf-derived-grid">

        {fields.map(
          (field) => {

            const fieldKey =
              `${question.question_code}.${field.key}`;

            return (

              <div
                key={field.key}
                className="ecf-derived-field"
              >

                <label className="ecf-label">
                  {field.label}
                </label>

                <input
                  className="ecf-form-input"
                  type="number"
                  value={
                    formData?.[
                      fieldKey
                    ] || ""
                  }
                  disabled={!isEditable}
                  onChange={(e) =>
                    onChange(
                      fieldKey,
                      e.target.value
                    )
                  }
                />

              </div>

            );

          }
        )}

        {/* RESULT INSIDE GRID */}

  <div className="ecf-derived-field">

    <label className="ecf-label">
      {schema.result?.label || "Result"}
    </label>

    <input
      className="ecf-form-input"
      type={
        schema.result?.type || "number"
      }
      value={result}
      readOnly
      disabled
    />

  </div>
      </div>

      {/* RESULT */}

{/* RESULT FIELD */}



    </div>

  );
};

export default DerivedRenderer;